import { inject, provideAppInitializer } from '@angular/core';
import { StatehandlerService } from '@praceprofirmy/system-domain';

const stateHandlerFn = (stateHandler: StatehandlerService) => {
  return () => {
    return stateHandler.initStateHandler();
  };
};

export const stateHandlerProviders = [
  provideAppInitializer(() => {
    const initializerFn = stateHandlerFn(inject(StatehandlerService));
    return initializerFn();
  }),
];
